/*=========================================================================================
  File Name: moduleAuth.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleStockState.js'
import mutations from './moduleStockMutations.js'
import actions from './moduleStockActions.js'
import getters from './moduleStockGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
